import { RouteRecordRaw } from "vue-router";
import { PAGE_TYPE } from "@supplier/meta";
import { defineAsyncComponent } from "vue";
import { useUserStore } from "@/stores/modules/user";
const statementStatisticsRouter: RouteRecordRaw[] = [
    {
        path: "WarehouseStatementStatistics",
        name: "WarehouseStatementStatistics",
        component: () => import("@/views/layouts/index.vue"),
        redirect: "/statementStatistics/project",
        meta: {
            title: "报表统计"
        },
        children: [
            {
                path: "/WarehouseStatementStatistics/project",
                name: "WarehouseProjectStatement",
                component: defineAsyncComponent(() => {
                    const userStore = useUserStore();
                    if (userStore?.isSAAS) {
                        return import("@/views/components/emptyPage/index.vue");
                    } else {
                        return import("@/views/pages/warehouseSupervision/statementStatistics/projectStatement/index.vue");
                    }
                }),
                meta: {
                    title: "项目报表",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_S_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_S_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_S_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "/WarehouseStatementStatistics/fund",
                name: "WarehouseFundStatement",
                component: defineAsyncComponent(() => {
                    const userStore = useUserStore();
                    if (userStore?.isSAAS) {
                        return import("@/views/components/emptyPage/index.vue");
                    } else {
                        return import("@/views/pages/warehouseSupervision/statementStatistics/fundStatement/index.vue");
                    }
                }),
                meta: {
                    title: "资金报表",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_S_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_S_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_S_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "/WarehouseStatementStatistics/customer",
                name: "WarehouseCustomerStatement",
                component: defineAsyncComponent(() => {
                    const userStore = useUserStore();
                    if (userStore?.isSAAS) {
                        return import("@/views/components/emptyPage/index.vue");
                    } else {
                        return import("@/views/pages/warehouseSupervision/statementStatistics/customerStatement/index.vue");
                    }
                }),
                meta: {
                    title: "客户报表",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_S_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_S_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_S_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "/WarehouseStatementStatistics/stock",
                name: "WarehouseStockStatement",
                meta: {
                    title: "库存报表"
                },
                redirect: "/WarehouseStatementStatistics/stock/reportPackage",
                children: [
                    {
                        path: "detailed",
                        name: "WarehouseStockDetailed",
                        component: defineAsyncComponent(() => {
                            const userStore = useUserStore();
                            if (userStore?.isSAAS) {
                                return import("@/views/components/emptyPage/index.vue");
                            } else {
                                return import(
                                    "@/views/pages/warehouseSupervision/statementStatistics/stockStatement/detailed/index.vue"
                                );
                            }
                        }),
                        meta: {
                            title: "库存明细",
                            isNotShowHeader: true,
                            pageType: PAGE_TYPE.LIST.code,
                            authOptions: [
                                {
                                    label: "查看",
                                    value: "ROLE_S_PROJECT_R"
                                },
                                {
                                    label: "查看所有",
                                    value: "ROLE_S_PROJECT_ALL_R"
                                },
                                {
                                    label: "处理",
                                    value: "ROLE_S_PROJECT_DEAL"
                                }
                            ]
                        }
                    },
                    {
                        path: "summary",
                        name: "WarehouseStockSummary",
                        component: defineAsyncComponent(() => {
                            const userStore = useUserStore();
                            if (userStore?.isSAAS) {
                                return import("@/views/components/emptyPage/index.vue");
                            } else {
                                return import(
                                    "@/views/pages/warehouseSupervision/statementStatistics/stockStatement/summary/index.vue"
                                );
                            }
                        }),
                        meta: {
                            title: "库存汇总",
                            isNotShowHeader: true,
                            pageType: PAGE_TYPE.LIST.code,
                            authOptions: [
                                {
                                    label: "查看",
                                    value: "ROLE_S_PROJECT_R"
                                },
                                {
                                    label: "查看所有",
                                    value: "ROLE_S_PROJECT_ALL_R"
                                },
                                {
                                    label: "处理",
                                    value: "ROLE_S_PROJECT_DEAL"
                                }
                            ]
                        }
                    },
                    {
                        path: "warehouseCoreLibrary",
                        name: "WarehouseStockLibrary",
                        component: defineAsyncComponent(() => {
                            const userStore = useUserStore();
                            if (userStore?.isSAAS) {
                                return import("@/views/components/emptyPage/index.vue");
                            } else {
                                return import(
                                    "@/views/pages/warehouseSupervision/statementStatistics/stockStatement/coreLibrary/index.vue"
                                );
                            }
                        }),
                        meta: {
                            title: "核库报表",
                            isNotShowHeader: true,
                            pageType: PAGE_TYPE.LIST.code,
                            authOptions: [
                                {
                                    label: "查看",
                                    value: "ROLE_S_PROJECT_R"
                                },
                                {
                                    label: "查看所有",
                                    value: "ROLE_S_PROJECT_ALL_R"
                                },
                                {
                                    label: "处理",
                                    value: "ROLE_S_PROJECT_DEAL"
                                }
                            ]
                        }
                    },
                    {
                        path: "warehouseCoreLibrary/detail/:id",
                        name: "WarehouseStockLibraryDetail",
                        component: () =>
                            import(
                                "@/views/pages/warehouseSupervision/statementStatistics/stockStatement/coreLibrary/detail.vue"
                            ),
                        meta: {
                            title: "核库报表明细",
                            isNotShowHeader: true,
                            activeMenu: "WarehouseStockLibrary",
                            hidden: true,
                            authOptions: [
                                {
                                    label: "查看",
                                    value: "ROLE_S_PROJECT_R"
                                },
                                {
                                    label: "查看所有",
                                    value: "ROLE_S_PROJECT_ALL_R"
                                },
                                {
                                    label: "处理",
                                    value: "ROLE_S_PROJECT_DEAL"
                                }
                            ]
                        }
                    }
                ]
            }
        ]
    }
];

export default statementStatisticsRouter;
